module.exports = __webpack_public_path__ + "static/media/payspot-logo.524bbb85.svg";